/* eslint-disable no-undef */
import {
  Box,
  IconButton,
  Drawer,
  Typography,
  Chip,
  Skeleton,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Close, ContentCopy, FileDownloadOutlined } from "@mui/icons-material";
import { useInvitationsContext } from "../../contexts/invitations/InvitationsContext";
//import { UNSelect, UNSelectOptions } from "un-react-ui-components";
import { useIntl } from "react-intl";
import { usePresentationsActions } from "../../contexts/presentation/UsePresentationsActions";
import { usePresentationsContext } from "../../contexts/presentation/PresentationsContext";
import Presentation from "../../core/models/Presentation";
import {
  DateFormat,
  formatLabel,
  formatLabelWithCapitalAllWords,
  getFormattedDate,
  getStatusColor,
} from "../../util/utils";
import { GRAY_60 } from "../../themes/colors";

interface PreviewDataDrawerProps {
  showDrawer: boolean;
  onClose: () => void;
}

interface StatusState {
  completed: boolean;
  pending: boolean;
  failure: boolean;
}

const PreviewDataDrawer = ({ showDrawer, onClose }: PreviewDataDrawerProps) => {
  const { selectedInvitation, setSelectedInvitation } = useInvitationsContext();
  const { presentationResponseData, presentationLoading } =
    usePresentationsContext();

  const [presentations, setPresentations] = useState<Presentation[]>(
    presentationResponseData?.data || []
  );

  //const [multipleStatus, setMultipleStatus] = useState<Array<string>>();
  const intl = useIntl();
  const { dispatchCleanPresentationsContext, dispatchGetPresentations } =
    usePresentationsActions();
  // const statusOptions: UNSelectOptions<string> = [
  //   {
  //     value: "completed",
  //     label: intl.formatMessage({
  //       id: "invitation.status.completed",
  //     }),
  //   },
  //   {
  //     value: "pending",
  //     label: intl.formatMessage({
  //       id: "invitation.status.pending",
  //     }),
  //   },
  //   {
  //     value: "failed",
  //     label: intl.formatMessage({
  //       id: "invitation.status.failed",
  //     }),
  //   },
  // ];

  useEffect(() => {
    if (selectedInvitation) {
      dispatchGetPresentations({
        filter: {
          data_sharing: selectedInvitation.id,
        },
        ordering: [{ modified: false }],
        page: 1,
        size: 1000,
      });
    }
    return () => {
      dispatchCleanPresentationsContext();
      setSelectedInvitation();
    };
  }, []);

  useEffect(() => {
    if (presentationResponseData) {
      setPresentations(presentationResponseData.data);
    }
  }, [presentationResponseData]);

  // const onClickCopy = (item: any) => {
  //   const allText = item.presentations
  //     .flatMap((presentation: any) =>
  //       Object.entries(
  //         presentation.presentation_data.revealed_attrs as Record<string, any>
  //       ).map(([key, value]) => `${value.raw}`)
  //     )
  //     .join(",");

  //   navigator.clipboard.writeText(allText);
  // };
  return (
    <Drawer anchor="right" open={showDrawer} onClose={onClose}>
      <Box width="38.875rem" className="px-8">
        <Box className="bg-white sticky top-0 w-full py-8">
          <Box className="flex justify-between items-center w-full">
            <Typography variant="h2" fontWeight={500}>
              {selectedInvitation?.email}
            </Typography>
            <IconButton className="p-0" onClick={onClose}>
              <Close />
            </IconButton>
          </Box>

          {/* <Box className="mt-7">
            <Typography fontSize="1rem" fontWeight={600} color="primary">
              <FileDownloadOutlined className="mr-2 text-[1.5rem]" />
              Download CSV
            </Typography>
          </Box> */}
          {/* <Box className={"flex space-x-4"}>
            <UNSelect
              placeholder="Status"
              placeholderTranslationKey={undefined}
              options={statusOptions}
              multiple
              isAutocomplete
              value={multipleStatus}
              onChange={(value) => setMultipleStatus(value as Array<string>)}
            />
            <UNSelect
              placeholder="Data Shared on"
              placeholderTranslationKey={undefined}
              options={statusOptions}
              multiple
              value={multipleStatus}
              onChange={(value) => setMultipleStatus(value as Array<string>)}
            />
          </Box> */}
        </Box>
        <Box>
          {presentationLoading
            ? [...Array(3)].map((_, index) => (
                <Box key={index} className="mt-6">
                  <Skeleton width="30%" height={20} />
                  <Box className="h-full mt-[1rem] rounded-[10px] bg-gray-input p-[1.25rem] space-y-[1.25rem]">
                    <Box className="flex justify-between items-center">
                      <Skeleton width="50%" height={30} />
                      <Skeleton width={60} height={30} />
                    </Box>
                    <Box className="rounded-[8px] bg-white p-6 space-y-4">
                      {[...Array(3)].map((_, idx) => (
                        <Box key={idx} className="flex justify-between">
                          <Box>
                            <Skeleton width={100} height={20} />
                            <Skeleton width={150} height={25} />
                          </Box>
                          <Skeleton variant="circular" width={24} height={24} />
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Box>
              ))
            : presentations.map((item, index) => (
                <Box>
                  <Typography variant="body2" className="pt-[1.0rem]">
                    {getFormattedDate(item?.created, DateFormat.DayOfMonthTime)}
                  </Typography>
                  <Box
                    key={`Step ${index + 1}`}
                    className="h-full mt-[1rem] rounded-[10px] bg-gray-input p-[1.25rem] space-y-[1.25rem]"
                  >
                    {item?.integration_steps?.map((integItem, index) => (
                      <>
                        {integItem?.presentations.length == 0 ? (
                          <Box>
                            <Typography variant="h2">
                              {integItem?.title}{" "}
                              <Typography component="span" fontWeight={400}>
                                {`| ${formatLabel(integItem?.presentation_configuration)}`}
                              </Typography>
                            </Typography>
                          </Box>
                        ) : null}
                        {integItem?.presentations?.map(
                          (presentation: any, presIndex: number) => (
                            <>
                              <Box className="flex justify-between items-center">
                                <Typography variant="h2">
                                  {integItem?.title}{" "}
                                  <Typography component="span" fontWeight={400}>
                                    {`| ${formatLabel(integItem?.presentation_configuration)}`}
                                  </Typography>
                                </Typography>

                                <Box className="flex align-center">
                                  <Chip
                                    color={getStatusColor(item.status)}
                                    label={presentation.status}
                                    className="mr-4"
                                  />
                                </Box>
                              </Box>
                              <Box
                                key={presIndex}
                                className="rounded-[8px] bg-white p-6 space-y-4"
                              >
                                <Typography fontWeight={500}>
                                  {`${formatLabel(integItem?.presentation_configuration)} ${presIndex + 1}`}
                                </Typography>
                                {Object.entries(
                                  presentation?.presentation_data
                                    ?.revealed_attrs ?? {}
                                ).map(([key, value], entryIndex) => {
                                  const castedValue = value as { raw: string };
                                  return (
                                    <Box
                                      key={key}
                                      className="flex justify-between"
                                    >
                                      <Box>
                                        <Typography
                                          variant="body2"
                                          color={GRAY_60}
                                        >
                                          {formatLabelWithCapitalAllWords(key)}
                                        </Typography>
                                        <Typography variant="body1">
                                          {castedValue.raw}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  );
                                })}
                              </Box>
                            </>
                          )
                        )}
                      </>
                    ))}
                  </Box>
                </Box>
              ))}
        </Box>
      </Box>
    </Drawer>
  );
};

export { PreviewDataDrawer };
